import { IStepProps, IStepsProps, StepsOrientation, StepsType } from '@amobee/component-library';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'campaign-vertical-stepper-content',
  templateUrl: './campaign-vertical-stepper-content.component.html',
  styleUrls: ['./campaign-vertical-stepper-content.component.scss']
})
export class CampaignVerticalStepperContentComponent implements OnInit {

  @Input() steps: Array<IStepProps>;
  @Input() completedStep: IStepsProps['completedStep'];

  stepsConfig: IStepsProps = {
    type: StepsType.ICON,
    orientation: StepsOrientation.VERTICAL
  }
  warningIcon: IStepProps['warningIcon'] = 'Time';

  constructor() { }

  ngOnInit() {
  }

}
